var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimemachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1041.34 594.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#Gradiente_sem_nome_6-9);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-36 {\r\n        opacity: .13;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#Gradiente_sem_nome_6-8);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#Gradiente_sem_nome_12-3);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#Gradiente_sem_nome_12-4);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#Gradiente_sem_nome_61-3);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#Gradiente_sem_nome_61-2);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#Gradiente_sem_nome_122);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#Gradiente_sem_nome_6-7);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#Gradiente_sem_nome_6-3);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#Gradiente_sem_nome_12-5);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#Gradiente_sem_nome_6-10);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#Gradiente_sem_nome_12-9);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#Gradiente_sem_nome_12-8);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#Gradiente_sem_nome_6-5);\r\n      }\r\n\r\n      .cls-37 {\r\n        clip-path: url(#clippath-1);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #ff35a3;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#Gradiente_sem_nome_12-11);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#Gradiente_sem_nome_12-2);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#Gradiente_sem_nome_61);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#Gradiente_sem_nome_61-4);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#Gradiente_sem_nome_12-6);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#Gradiente_sem_nome_54-4);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#Gradiente_sem_nome_6);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#Gradiente_sem_nome_6-4);\r\n      }\r\n\r\n      .cls-38 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#Gradiente_sem_nome_54);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#Gradiente_sem_nome_12-12);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#Gradiente_sem_nome_12);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#Gradiente_sem_nome_6-11);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#Gradiente_sem_nome_54-3);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#Gradiente_sem_nome_54-2);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: url(#Gradiente_sem_nome_6-6);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#Gradiente_sem_nome_12-7);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#Gradiente_sem_nome_62);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#Gradiente_sem_nome_6-2);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#Gradiente_sem_nome_12-10);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "0 274.34 797.87 0 1041.34 594.4 0 274.34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_62",
    "data-name": "Gradiente sem nome 62",
    x1: 118.97,
    y1: 9.65,
    x2: 1096.32,
    y2: 454.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c1c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#421765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#290b45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17032d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 80.17,
    y: 334.39,
    width: 1066.05,
    height: 355.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    "data-name": "Gradiente sem nome 6",
    x1: -22.34,
    y1: 839.05,
    x2: -20.92,
    y2: 839.05,
    gradientTransform: "translate(4540.39 160325.76) scale(190.47 -190.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f72ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f72ea5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-2",
    "data-name": "Gradiente sem nome 6",
    x1: -29.24,
    y1: 840.73,
    x2: -27.82,
    y2: 840.73,
    gradientTransform: "translate(2377.76 54294.31) scale(63.97 -63.97)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-3",
    "data-name": "Gradiente sem nome 6",
    x1: -20.76,
    y1: 838.64,
    x2: -19.34,
    y2: 838.64,
    gradientTransform: "translate(7229.76 292415.58) scale(348.04 -348.04)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-4",
    "data-name": "Gradiente sem nome 6",
    x1: -20.25,
    y1: 838.54,
    x2: -18.83,
    y2: 838.54,
    gradientTransform: "translate(9473.69 402985.49) scale(479.97 -479.97)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-5",
    "data-name": "Gradiente sem nome 6",
    x1: -19.5,
    y1: 838.36,
    x2: -18.08,
    y2: 838.36,
    gradientTransform: "translate(18161.37 825254.7) scale(983.75 -983.75)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-6",
    "data-name": "Gradiente sem nome 6",
    x1: -19.5,
    y1: 838.38,
    x2: -18.08,
    y2: 838.38,
    gradientTransform: "translate(18937.24 867502.55) scale(1034.21 -1034.21)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12",
    "data-name": "Gradiente sem nome 12",
    x1: -21.74,
    y1: 839.05,
    x2: -20.32,
    y2: 839.05,
    gradientTransform: "translate(4810.6 160325.76) scale(190.47 -190.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f72ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f72ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-2",
    "data-name": "Gradiente sem nome 12",
    x1: -28.68,
    y1: 840.73,
    x2: -27.26,
    y2: 840.73,
    gradientTransform: "translate(2462.65 54294.31) scale(63.97 -63.97)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-3",
    "data-name": "Gradiente sem nome 12",
    x1: -20.14,
    y1: 838.64,
    x2: -18.72,
    y2: 838.64,
    gradientTransform: "translate(7739.58 292415.58) scale(348.04 -348.04)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-4",
    "data-name": "Gradiente sem nome 12",
    x1: -19.61,
    y1: 838.54,
    x2: -18.19,
    y2: 838.54,
    gradientTransform: "translate(10200.08 402985.49) scale(479.97 -479.97)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-5",
    "data-name": "Gradiente sem nome 12",
    x1: -18.94,
    y1: 838.36,
    x2: -17.51,
    y2: 838.36,
    gradientTransform: "translate(19475.75 825254.7) scale(983.75 -983.75)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-6",
    "data-name": "Gradiente sem nome 12",
    x1: -18.87,
    y1: 838.38,
    x2: -17.44,
    y2: 838.38,
    gradientTransform: "translate(20499.07 867502.55) scale(1034.21 -1034.21)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-7",
    "data-name": "Gradiente sem nome 6",
    x1: -22.39,
    y1: 838.57,
    x2: -20.97,
    y2: 838.57,
    gradientTransform: "translate(4540.39 -159714.14) scale(190.47)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-8",
    "data-name": "Gradiente sem nome 6",
    x1: -29.39,
    y1: 839.3,
    x2: -27.97,
    y2: 839.3,
    gradientTransform: "translate(2377.76 -53682.69) scale(63.97)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_122",
    "data-name": "Gradiente sem nome 122",
    x1: -20.79,
    y1: 838.38,
    x2: -19.37,
    y2: 838.38,
    gradientTransform: "translate(7229.76 -291803.96) scale(348.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f72ea5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f72ea5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-9",
    "data-name": "Gradiente sem nome 6",
    x1: -20.27,
    y1: 838.35,
    x2: -18.85,
    y2: 838.35,
    gradientTransform: "translate(9473.69 -402373.87) scale(479.97)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-10",
    "data-name": "Gradiente sem nome 6",
    x1: -19.51,
    y1: 838.27,
    x2: -18.09,
    y2: 838.27,
    gradientTransform: "translate(18161.37 -824643.08) scale(983.75)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-11",
    "data-name": "Gradiente sem nome 6",
    x1: -19.51,
    y1: 838.29,
    x2: -18.09,
    y2: 838.29,
    gradientTransform: "translate(18937.24 -866890.93) scale(1034.21)",
    xlinkHref: "#Gradiente_sem_nome_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-7",
    "data-name": "Gradiente sem nome 12",
    x1: -21.79,
    y1: 838.57,
    x2: -20.37,
    y2: 838.57,
    gradientTransform: "translate(4810.6 -159714.14) scale(190.47)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-8",
    "data-name": "Gradiente sem nome 12",
    x1: -28.83,
    y1: 839.3,
    x2: -27.41,
    y2: 839.3,
    gradientTransform: "translate(2462.65 -53682.69) scale(63.97)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-9",
    "data-name": "Gradiente sem nome 12",
    x1: -20.17,
    y1: 838.38,
    x2: -18.75,
    y2: 838.38,
    gradientTransform: "translate(7739.58 -291803.96) scale(348.04)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-10",
    "data-name": "Gradiente sem nome 12",
    x1: -19.63,
    y1: 838.35,
    x2: -18.21,
    y2: 838.35,
    gradientTransform: "translate(10200.08 -402373.87) scale(479.97)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-11",
    "data-name": "Gradiente sem nome 12",
    x1: -18.94,
    y1: 838.27,
    x2: -17.52,
    y2: 838.27,
    gradientTransform: "translate(19475.75 -824643.08) scale(983.75)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-12",
    "data-name": "Gradiente sem nome 12",
    x1: -18.87,
    y1: 838.29,
    x2: -17.45,
    y2: 838.29,
    gradientTransform: "translate(20499.07 -866890.93) scale(1034.21)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_54",
    "data-name": "Gradiente sem nome 54",
    x1: 557.12,
    y1: 198.09,
    x2: 557.12,
    y2: 106.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fbc3ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f393c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ea5fb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#cb63b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7e6fb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0d81b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0e81b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#1585b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#218bb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3294bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#489fc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#63adcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#83bed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#90c5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#92c6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#acd3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c2dee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d3e6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#dfecf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e6f0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e8f1f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#dfecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#cfe3eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c6dee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#c4dde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#bedae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#afd3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#96c7da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#72b7d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#45a2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0e89b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0083b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_61",
    "data-name": "Gradiente sem nome 61",
    x1: 557.12,
    y1: 200.09,
    x2: 557.12,
    y2: 104.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#013a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#134856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#446d79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#92aab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_54-2",
    "data-name": "Gradiente sem nome 54",
    x1: 613.8,
    x2: 613.8,
    xlinkHref: "#Gradiente_sem_nome_54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_61-2",
    "data-name": "Gradiente sem nome 61",
    x1: 613.8,
    x2: 613.8,
    xlinkHref: "#Gradiente_sem_nome_61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_54-3",
    "data-name": "Gradiente sem nome 54",
    x1: 693.61,
    x2: 693.61,
    xlinkHref: "#Gradiente_sem_nome_54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_61-3",
    "data-name": "Gradiente sem nome 61",
    x1: 693.61,
    x2: 693.61,
    xlinkHref: "#Gradiente_sem_nome_61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_54-4",
    "data-name": "Gradiente sem nome 54",
    x1: 793.6,
    x2: 793.6,
    xlinkHref: "#Gradiente_sem_nome_54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_61-4",
    "data-name": "Gradiente sem nome 61",
    x1: 793.6,
    x2: 793.6,
    xlinkHref: "#Gradiente_sem_nome_61"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "0 274.34 797.87 0 1041.34 594.4 0 274.34"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "286.36 694.01 555.95 330.13 555.95 330.13 286.36 694.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-34",
    points: "508.1 694.01 597.64 330.13 597.64 330.13 508.1 694.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "3.98 745.18 497.76 330.13 497.76 330.13 3.98 745.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "-243.82 694.01 437.74 330.13 437.74 330.13 -243.82 694.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "-1019.9 694.01 378.04 330.13 378.04 330.13 -1019.9 694.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "-1231.69 563.24 238.1 330.13 238.1 330.13 -1231.69 563.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "940.03 694.01 670.44 330.13 670.44 330.13 940.03 694.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "718.3 694.01 628.75 330.13 628.75 330.13 718.3 694.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1222.42 745.18 728.63 330.13 728.63 330.13 1222.42 745.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1470.21 694.01 788.66 330.13 788.66 330.13 1470.21 694.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "2246.29 694.01 848.35 330.13 848.35 330.13 2246.29 694.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "2458.08 563.24 988.29 330.13 988.29 330.13 2458.08 563.24"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "276.68 -174.04 546.27 189.83 546.27 189.83 276.68 -174.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "498.42 -174.04 587.97 189.83 587.97 189.83 498.42 -174.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "-5.7 -225.21 488.08 189.83 488.08 189.83 -5.7 -225.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-253.5 -174.04 428.06 189.83 428.06 189.83 -253.5 -174.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "-1029.58 -174.04 368.36 189.83 368.36 189.83 -1029.58 -174.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "-1241.37 -43.27 228.43 189.83 228.43 189.83 -1241.37 -43.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "930.36 -174.04 660.76 189.83 660.76 189.83 930.36 -174.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "708.62 -174.04 619.07 189.83 619.07 189.83 708.62 -174.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "1212.74 -225.21 718.96 189.83 718.96 189.83 1212.74 -225.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-35",
    points: "1460.54 -174.04 778.98 189.83 778.98 189.83 1460.54 -174.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "2236.62 -174.04 838.68 189.83 838.68 189.83 2236.62 -174.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "2448.4 -43.27 978.61 189.83 978.61 189.83 2448.4 -43.27"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m86.47,384.16l4.47-1.84c2.17,8.42,8.57,16.32,20.75,16.32,13.48,0,28.38-9.74,46.41-34.49,26.92-37.12,54.03-99.26,63.12-142.7,8.64-5,17.44-7.9,21.32-7.9,2.33,0,3.96,1.05,3.28,5-.41,2.37-2.39,10.79-4.81,20.27-3.9,15.01-8.93,35.02-11.99,52.66-4.84,27.91-3.56,42.92,4.73,42.92,9.59,0,26.84-20.27,48.21-64.24,6.57-13.95,13.94-31.07,21.55-49.5,8.55-4.48,16.52-7.11,20.15-7.11,2.85,0,4.18,1.32,3.72,3.95-.55,3.16-4.13,11.85-10.03,27.91-15.79,43.18-32.5,93.2-37.67,122.96-2.92,16.85-3.94,37.65,6.42,37.65s27.04-18.43,46.41-74.77l6.08.79c-22.31,65.82-44.58,86.62-62.2,86.62-19.18,0-23.05-23.96-17.25-57.4,3.93-22.64,11.72-46.6,19.58-69.51h-.52c-16,29.49-36.3,56.87-54.96,56.87s-19.35-27.38-12.49-62.4h-.52c-10.1,26.86-22.9,55.82-36.99,78.72-18.03,29.23-39.4,50.82-62.46,50.82-17.88,0-25.44-13.17-24.32-31.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m311,373.1c3.61-20.8,15.24-40.02,28.27-52.39,12.77-12.37,29.13-20.01,45.97-20.01,10.63,0,19.71,2.9,28.34,8.43-6.52,18.17-15.28,44.76-18.57,63.72-3.06,17.64-1.86,31.59,6.44,31.59,9.59,0,25.36-19.22,44.06-73.19l6.08.79c-22.52,65.56-41.35,82.94-57.15,82.94-17.88,0-22.85-22.12-18.45-44.5h-.52c-14.54,30.02-28.93,44.23-43.44,44.23s-25.6-15.27-21.03-41.6Zm56.77-1.58c8.63-16.85,16.9-37.65,23.15-54.24-4.54-3.69-10.7-5.53-16.92-5.53-7.52,0-15.23,2.63-21.89,8.16-8.75,11.59-17.01,30.81-20.16,48.97s-.54,34.49,8.27,34.49c7,0,16.16-9.48,27.56-31.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m456.75,315.7c11.14-8.95,24.51-15.8,36.43-15.8,13.99,0,20.12,9.48,18.48,18.96-1.55,8.95-9.74,15.8-18.98,15.27.58-1.84.76-2.9.99-4.21,1.78-10.27-.6-18.96-9.67-18.96-7.52,0-15.78,5.79-22.51,14.74-8.4,11.06-12.98,25.54-14.81,36.07-4.43,25.54,4.87,42.13,20.94,42.13,18.14,0,44.77-20.54,62.89-72.67l6.08.79c-21.13,60.56-53.22,82.67-77.58,82.67-21.77,0-38.87-17.9-33.76-47.39,3.2-18.43,14.31-37.65,31.5-51.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m516.84,378.63c5.94-34.23,19.76-75.04,35.56-110.84,8.12-18.43,16.4-34.75,24.34-47.66,6.78-4.74,17.64-10.53,22.04-10.53,2.59,0,4.82,2.11,6.95,4.74,4.91,6.06,9.77,16.85,6.99,32.91-4.89,28.17-30.45,58.98-59.03,66.88-5.87,17.38-12.3,39.49-14.81,53.97-.73,4.21-1.23,7.11-1.57,10.53h.78c4.45-13.69,9.92-25.8,15.5-35.54,12.25-21.33,28.12-36.6,44.55-38.7,10.61,1.58,17.07,7.63,20.67,15.27-6.34,17.11-14.32,34.75-17.61,53.71-3.11,17.9-.68,30.81,6.83,30.81,9.33,0,25.14-17.9,44.27-72.93l6.08.79c-22.87,66.09-42.03,82.41-57.84,82.41-13.73,0-24.45-12.9-19.52-41.34,3.29-18.96,12.68-38.7,14.05-46.6.82-4.74-.66-8.16-5.32-8.16-3.63,0-7.58,1.84-12.01,5-7.22,5.79-14.97,16.06-22.31,30.01-10.87,20.8-16.59,41.86-19.32,56.08-5.99,3.16-11.71,4.74-14.3,4.74-10.37,0-7.03-23.7-4.97-35.54Zm80.94-122.96c2.06-11.85.32-24.22-6.39-31.86-12.8,24.49-24.64,52.39-34.77,82.41,20.49-6.06,37.42-28.96,41.17-50.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m659.57,307.28c4.91-2.9,13.28-6.32,17.42-6.32,3.11,0,4.34,1.84,3.66,5.79-.64,3.69-3.7,12.37-7.56,22.64-5.36,14.48-11.63,32.65-14.14,47.13-2.79,16.06-.91,27.65,7.12,27.65,10.37,0,25.84-18.96,44.79-72.93l6.08.79c-23.09,65.82-41.51,82.41-58.36,82.41-14.25,0-24.16-11.59-19.46-38.7,3.29-18.96,13.68-44.5,20.43-68.46Zm15.63-45.29c1.33-7.64,8.34-13.69,15.85-13.69s12.42,6.06,11.1,13.69c-1.33,7.64-8.38,13.95-15.9,13.95s-12.38-6.32-11.05-13.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m696.26,382.58c4.16-23.96,14.9-50.02,21.62-75.3,4.91-2.9,13.54-6.32,17.68-6.32,3.11,0,4.3,2.11,3.66,5.79-1.01,5.79-8.24,22.12-13.9,39.76-3.34,10.27-6.87,23.17-8.52,32.65h.78c3.5-9.74,8.59-22.64,15.27-34.23,13.84-24.49,30.73-42.65,48.5-45.02,9.22,2.11,16.6,7.37,20.72,15.01-6.74,17.9-16.43,37.91-20.08,58.98-3.11,17.9-.85,30.28,7.18,30.28,9.33,0,25.14-17.9,44.27-72.93l6.08.79c-22.96,66.61-42.03,82.41-58.1,82.41-13.99,0-24.59-12.11-19.65-40.55,3.79-21.85,14.63-43.97,16.09-52.39.82-4.74-.7-7.9-5.37-7.9-11.92,0-27.86,23.17-35.91,38.18-10.29,18.96-17.31,40.02-21.45,57.92-5.69,2.9-11.14,4.48-13.73,4.48-9.07,0-7.29-19.22-5.14-31.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m846.26,314.12c10.44-7.9,22.59-13.69,32.96-13.69,12.18,0,18.32,7.9,16.27,19.75-1.87,10.79-9.43,20.01-19.52,27.38-12.74,9.22-29.6,15.27-41.67,17.64-3.21,24.49,7.14,39.49,23.98,39.49,15.29,0,29.88-12.37,41.47-28.43l4.47,2.63c-14.22,23.7-35.38,36.6-54.81,36.6-22.81,0-41.21-17.9-35.86-48.71,3.11-17.9,14.19-38.44,32.72-52.66Zm31.86,10.53c1.42-8.16-1.3-13.43-8.29-13.43s-14.48,5.79-21.45,16.06c-6.96,10.27-10.91,21.06-12.77,30.28,14.45-2.63,38.99-12.64,42.51-32.91Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m593.04,121.85h-28.03l-13.44,76.24h-18.86l13.44-76.24h-27.66l2.69-15.27h74.55l-2.69,15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m595.74,106.57l-2.69,15.27h-28.03l-13.44,76.24h-18.86l13.44-76.24h-27.66l2.69-15.27h74.55m0-2h-74.55l-1.97,1.65-2.69,15.27,1.97,2.35h25.27l-13.03,73.9,1.97,2.35h18.86l1.97-1.65,13.15-74.59h26.36l1.97-1.65,2.69-15.27-1.97-2.35h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m615.16,198.09h-18.86l16.14-91.52h18.86l-16.14,91.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m631.3,106.57l-16.14,91.52h-18.86l16.14-91.52h18.86m0-2h-18.86l-1.97,1.65-16.14,91.52,1.97,2.35h18.86l1.97-1.65,16.14-91.52-1.97-2.35h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m678.18,106.57l11.8,66.37,35.09-66.37h24.77l-16.14,91.52h-18.92l4.41-25.02,9.5-43.18-36.73,68.2h-12.95l-12.62-68.13-5.72,43.12-4.41,25.02h-18.86l16.14-91.52h24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m749.83,106.57l-16.14,91.52h-18.92l4.41-25.02,9.5-43.18-36.73,68.2h-12.95l-12.62-68.13-5.72,43.12-4.41,25.02h-18.86l16.14-91.52h24.64l11.8,66.37,35.09-66.37h24.77m0-2h-24.77l-1.77,1.07-32.37,61.23-10.79-60.65-1.97-1.65h-24.64l-1.97,1.65-16.14,91.52,1.97,2.35h18.86l1.97-1.65,4.41-25.02v-.08s4.08-30.64,4.08-30.64l10.33,55.75,1.97,1.64h12.95l1.76-1.05,29.94-55.59-6.42,29.19-.02.08-4.41,25.02,1.97,2.35h18.92l1.97-1.65,16.14-91.52-1.97-2.35h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m816.98,158.43h-36.2l-4.32,24.51h42.49l-2.67,15.15h-61.35l16.14-91.52h61.22l-2.69,15.27h-42.36l-3.85,21.81h36.2l-2.6,14.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m832.28,106.57l-2.69,15.27h-42.36l-3.85,21.81h36.2l-2.6,14.77h-36.2l-4.32,24.51h42.49l-2.67,15.15h-61.35l16.14-91.52h61.22m0-2h-61.22l-1.97,1.65-16.14,91.52,1.97,2.35h61.35l1.97-1.65,2.67-15.15-1.97-2.35h-40.11l3.62-20.51h34.53l1.97-1.65,2.6-14.77-1.97-2.35h-33.82l3.14-17.81h40.69l1.97-1.65,2.69-15.27-1.97-2.35h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimemachine);
export default __webpack_public_path__ + "static/media/timemachine.c03674b9b6621c78af873f726a332732.svg";
export { ForwardRef as ReactComponent };